// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2Uz4t","actionsCol":"EnrolledClinics_actionsCol__f8zRi"};